import React, { useState } from "react";
import NumPad from "../numpad/NumPad";
import "./reportdate.css";
import { useKioskContext } from "../../store/Context";
import { validateParticipant } from "../../Api/API";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";
import { useNavigate } from "react-router-dom";

const ReportDate = () => {
  const { text, setCurrentScreen, language } = useKioskContext();
  const navigate = useNavigate();

  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);

  const handleNextClick = async () => {
    if (loading) return;

    const offenderId = localStorage.getItem("offenderId");

    if (!offenderId) {
      toast.error(
        language === "1"
          ? "Número de participante no encontrado."
          : "Participant number not found.",
        { toastId: "error" },
      );
      return;
    }

    // NumPad date format: MM / DD / YYYY
    const dateParts = date.split(/\s*\/\s*/);

    if (dateParts.length !== 3) {
      toast.error(
        language === "1"
          ? "Ingrese una fecha de nacimiento válida."
          : "Please enter a valid date of birth.",
        { toastId: "error" },
      );
      return;
    }

    const [month, day, year] = dateParts;

    const validDate =
      /^\d{2}$/.test(month) &&
      /^\d{2}$/.test(day) &&
      /^\d{4}$/.test(year) &&
      Number(month) >= 1 &&
      Number(month) <= 12 &&
      Number(day) >= 1 &&
      Number(day) <= 31;

    if (!validDate) {
      toast.error(
        language === "1"
          ? "Ingrese una fecha de nacimiento válida."
          : "Please enter a valid date of birth.",
        { toastId: "error" },
      );
      return;
    }

    // Preserve existing date format for the API
    const formattedDate = `${year}-${month}-${day}`;

    setLoading(true);

    try {
      const { data, error } = await validateParticipant(
        formattedDate,
        offenderId,
      );

      if (error) {
        toast.error(error, {
          toastId: "error",
        });
        return;
      }

      if (!data?.success || !data?.personId || !data?.sessionId) {
        toast.error(
          language === "1"
            ? "No se pudo confirmar su identidad."
            : "Your identity could not be confirmed.",
          { toastId: "error" },
        );
        return;
      }

      // Save participant details
      localStorage.setItem("personId", data.personId);
      localStorage.setItem("sessionId", data.sessionId);
      localStorage.setItem("participantName", data.participantName || "");
      localStorage.setItem("email", data.emailAddress || "");
      localStorage.setItem("dob", formattedDate);
      localStorage.setItem(
        "showDrugTest",
        String(data.drugTestCheck ?? "false").toLowerCase(),
      );

      // Remove any legacy JWT token
      localStorage.removeItem("token");

      // Save screen and navigate to Home
      localStorage.setItem("currentScreen", "3");
      setCurrentScreen(3);
      navigate("/");
    } catch (err) {
      console.error("Validate participant error:", err);

      toast.error(
        language === "1" ? "Algo salió mal." : "Something went wrong.",
        { toastId: "error" },
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <Loader />}

      <div className="primaryText">{text.reportDateText}</div>

      <div className="inputContainer">
        <input
          value={date}
          placeholder={text.dateFormat}
          disabled={true}
          className="reportInputField"
        />
      </div>

      <NumPad nextBtnFunc={handleNextClick} value={date} setValue={setDate} />
    </div>
  );
};

export default ReportDate;
